import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { getQueryParams } from "../utils/HelperFunctions";


export default function PremiumMemberships() {
  const Navigate = useNavigate();

  const queryParams = getQueryParams(Location?.search);
  const { leadId } = queryParams;

  const [catalog, setCatalog] = useState()
  const [loading, setLoading] = useState(false)

  const { mutate: subscriptionCatalog } = useMutation({
    mutationFn: (data) => {
      setLoading(true)
      return getRequest("/lead/subscription/catalog", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        setCatalog(data?.data.reverse())
        setLoading(false)
      }

    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setLoading(false)
    },
  });

  useEffect(() => {
    subscriptionCatalog()
  }, [])


  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest("/lead/subscription", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const premiumCatalogDetail = catalog?.find((ele) => ele?.name === "Premium")

  const handleSubscription = () => {
    const payload = {
      priceId: premiumCatalogDetail?.prices[0]?.id,
      leadId: leadId
    };
    mutate(payload);
  };


  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-premium-profile-sec">
                  <div className="my-premium-title">
                    <h4>Upgrade to SparkPro Premium for Just £120 per month!</h4>
                    <p>Ready to take your electrical business to the next level? </p>
                    <p>With SparkPro Premium, you get priority access to leads and exclusive visibility perks—all designed to help you win more jobs with less effort.</p>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="update-spark-side">
                  {/* <img src={require("../assets/images/spark-blaze-img.svg").default} alt="spark-blaze-img" /> */}

                  <span className="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 180 180" fill="none">
                      <path d="M6.66634 89.9999C6.66634 43.9762 43.9759 6.6666 89.9997 6.6666C136.023 6.6666 173.333 43.9762 173.333 89.9999C173.333 136.024 136.023 173.333 89.9997 173.333C43.9759 173.333 6.66634 136.024 6.66634 89.9999Z" fill="#FFC130" />
                      <path d="M133.332 82.8008L125.132 119.034C124.969 119.792 124.547 120.47 123.938 120.951C123.33 121.432 122.573 121.685 121.798 121.668H57.9316C57.1564 121.685 56.3995 121.432 55.7911 120.951C55.1827 120.47 54.7609 119.792 54.5982 119.034L46.6649 82.8008C46.5314 82.1888 46.5732 81.5508 46.7854 80.9615C46.9977 80.3722 47.3718 79.8542 47.8649 79.4675C48.3594 79.0795 48.9535 78.8388 49.5787 78.7742C50.2038 78.7095 50.8346 78.8228 51.3982 79.1008L70.8652 88.5342L86.9985 60.0008C87.2892 59.4878 87.7105 59.0611 88.2198 58.7642C88.7298 58.4674 89.3085 58.311 89.8985 58.311C90.4878 58.311 91.0672 58.4674 91.5765 58.7642C92.0858 59.0611 92.5078 59.4878 92.7985 60.0008L108.932 88.5675L128.532 79.0675C129.099 78.7668 129.742 78.6362 130.382 78.6915C131.022 78.7475 131.632 78.9868 132.139 79.3815C132.646 79.7762 133.028 80.3082 133.24 80.9148C133.452 81.5215 133.483 82.1768 133.332 82.8008Z" fill="white" />
                    </svg>
                  </span>
                </div>
              </Col>
            </Row>

            <div className="why-go-premium-sec">
              <div className="premium-heading">
                <h2>Why Go Premium?</h2>
              </div>
              <div className="list-of-premium">
                <h3>🔥 More Leads, More Opportunities</h3>
                <h3>✔ 20 Quotes (Credits) Per Month – <span>Claim up to 20 job leads every month at no extra cost! No need to top up credits constantly.</span></h3>

                <h3>🏆 Stay at the Top of Listings</h3>
                <h3>✔ Top Placement in Search Results – <span>Be automatically featured at the top when a customer searches for an electrician in your area. You’ll be seen first!</span></h3>
                <h3>
                <span className="crown" >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 27 27"
                                                fill="none"
                                              >
                                                <rect
                                                  width="25"
                                                  height="25"
                                                  rx="12.5"
                                                  transform="matrix(-1 0 0 1 26 1)"
                                                  fill="#FFC130"
                                                  stroke="white"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </span>
                  
                   Build Trust with a  Gold Premium Badge</h3>
                <h3> ✔ Gold Premium Badge -<span>Stand out as a top-tier electrician with a Gold Premium Badge, giving customers confidence in your expertise.</span></h3>
              </div>
            </div>

            <div className="compare-plans">
              <div className="compare-title">
                <h3>Compare Plans</h3>
              </div>

              <div className="my-custom-table">
                <table>
                  <tr>
                    <th>Feature</th>
                    <th>Standard Plan £80pm</th>
                    <th>Premium Plan £120pm</th>
                  </tr>
                  <tbody>

                    <tr>
                      <td>Included Monthly Quotes</td>
                      <td> 10 Per Month  </td>
                      <td>20 Per Month</td>
                    </tr>

                    {/* <tr>
                      <td>Public Contact Details</td>

                      <td>
                        <div className="cross-plans">
                          <div> Hidden </div>
                          <div className="cross-image"><img src={require("../assets/images/red-cross.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>

                      <td>
                        <div className="cross-plans">
                          <div> Visible </div>
                          <div className="cross-image"><img src={require("../assets/images/green-tick.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>
                    </tr> */}

                    <tr>
                      <td>Auto-Top Placement in Listings</td>

                      <td>
                        <div className="cross-plans">
                          <div> Not Included </div>
                          <div className="cross-image"><img src={require("../assets/images/red-cross.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>

                      <td>
                        <div className="cross-plans">
                          <div> Included </div>
                          <div className="cross-image"><img src={require("../assets/images/green-tick.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Gold Premium Badge</td>
                      <td>
                        <div className="cross-plans">
                          <div> Not Included </div>
                          <div className="cross-image"><img src={require("../assets/images/red-cross.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>
                      <td>
                        <div className="cross-plans">
                          <div> Included </div>
                          <div className="cross-image"><img src={require("../assets/images/green-tick.svg").default} alt="spark-blaze-img" /> </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="footer-text">
                <p>Going Premium gives you a competitive edge, making it easier to land high-quality jobs while reducing your cost per lead!</p>
              </div>

              <div className="upgrade-btn">
                <button className="btn-custom" onClick={() => handleSubscription()}>Upgrade Now</button>
              </div>

            </div>
          </div>
        </Container>
      </Layout>
    </>
  );
}
